import { BaseSelect } from 'parkdepot-shared/components/Select'
import { FormControl } from 'parkdepot-shared/components/FormControl'
import React from 'react'
import { Value } from 'baseui/select'
import { useTranslation } from 'react-i18next'

interface VehicleTypeSelectProps {
    onChange: (value: Value) => void
    value: Value | null
    options: Value
}

const PolicyContextSelect = ({ onChange, value, options }: VehicleTypeSelectProps) => {
    const { t } = useTranslation()

    return (
        <FormControl label={t('carpay.paymentInput.vehicleType')}>
            <BaseSelect
                overrides={{
                    Input: { props: { 'data-testid': 'user-input-context-select', readOnly: true } },
                    Root: { props: { 'data-testid': 'user-input-context-select-root' } }
                }}
                value={value ?? []}
                onChange={(options) => onChange(options.value)} // We need to do this... BaseUI does not support generics
                searchable={false}
                clearable={false}
                placeholder={t('carpay.paymentInput.vehicleType')}
                options={options}
                labelKey="label"
                valueKey="id"
            />
        </FormControl>
    )
}

export default PolicyContextSelect
